import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type QuoteRequestUpdateClientResponse = ClientInferResponseBody<
  typeof contract.quoteRequests.updateClient
>;

export const updateQuoteRequestClient = async ({
  id,
  clientId,
}: {
  id: string;
  clientId: string;
}): Promise<QuoteRequestUpdateClientResponse | null> => {
  const response = await api.quoteRequests.updateClient.mutation({
    body: { clientId },
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
